import React from 'react'
import { render } from "react-dom";

// Images (jpg, jpeg, png) are imported  here.
// This will copy all static images under `frontend/images` to the output
// folder and reference them with the image_pack_tag helper in views
// (e.g <%= image_pack_tag 'hero.png' %>) or the `imagePath` JavaScript helper
// below.

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

import App from "lib/App"
import ErrorReporting from "ErrorReporting";
import VenueAdmin from "routes/VenueAdmin";

document.addEventListener("DOMContentLoaded", () => {
  render(
    <ErrorReporting>
      <App>
        <VenueAdmin />
      </App>
    </ErrorReporting>,
    document.getElementById("app")
  );
});

